<template>
  <v-container fluid grid-list-xl>
    <v-form
      ref="form"
      lazy-validation
    >
      <v-layout row wrap>
        <v-flex>
          <v-text-field
            label="Account ID"
            v-model="filter.account_id"
            box
            hide-details
          />
        </v-flex>
        <v-flex>
          <v-text-field
            label="Order ID"
            v-model="filter.order_id"
            box
            hide-details
          />
        </v-flex>
        <v-flex>
          <v-text-field
            label="Reference #"
            v-model="filter.reference_number"
            box
            hide-details
          />
        </v-flex>
        <v-flex>
          <v-text-field
            label="Batch #"
            v-model="filter.batch_number"
            box
            hide-details
          />
        </v-flex>
      </v-layout>

      <v-divider class="primary" />

      <v-layout row wrap justify-end>
        <v-btn color="primary" @click="search">Search</v-btn>
      </v-layout>
    </v-form>

    <v-layout row wrap>
      <v-flex xs6>
        Local:
        <VueJsonPrettyWrapper :data="transactionLocal"></VueJsonPrettyWrapper>
      </v-flex>
      <v-flex xs6>
        Remote:
        <VueJsonPrettyWrapper :data="transactionRemote"></VueJsonPrettyWrapper>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import VueJsonPrettyWrapper from '@/components/VueJsonPrettyWrapper.vue'

import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  components: {VueJsonPrettyWrapper},

  data: function () {
    return {
      filter: {
        account_id: 0,
        order_id: 0,
        reference_number: 0,
        batch_number: 0
      },
      transactionLocal: {},
      transactionRemote: {}
    }
  },

  created () {
    if (!this.hasPermission('superuser')) {
      this.$store.commit('error', 'Access Denied')
      this.$router.go(-1)
    }
  },

  mounted () {
  },

  destroyed () {
  },

  computed: {
  },

  watch: {
  },

  methods: {
    async search () {
      try {
        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'get',
          url: '/fpg_transactions',
          params: this.filter
        })

        console.log(result)

        this.transactionLocal = result.data.data.local
        this.transactionRemote = result.data.data.fpg
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      } finally {
        Bus.$emit('closeWaitModal')
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/fpg/TransactionSearch.vue